// src/index.js

import React from 'react';
import ReactDOM from 'react-dom/client';
import Sati from './pages/Sati';
import MjesecniSati from './pages/MjesecniSati';
import MojTjedan from './pages/MojTjedan';
import Praznici from './pages/Praznici';

import Login from './authPage/Login';
import Navbar from './components/Navbar';
import DocumentHead from './components/DocumentHead';
import ProtectedRoute from './config/ProtectedRoute';
import RequireAuthRoute from './config/RequireAuthRoute';
import { AuthProvider } from './config/AuthProvider';
import { LoadingProvider } from './config/LoadingContext';
import Modal from 'react-modal';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

import './index.css'; // Vaš globalni CSS


Modal.setAppElement('#root'); // Potrebno za react-modal

const Root = () => {
  return (
    <Router>
      <DocumentHead />
      <Navbar />
      <Routes>
        <Route 
          path="/" 
          element={<Navigate to="/sati" replace />} 
        />
        <Route 
          path="/sati" 
          element={
            <ProtectedRoute>
              <Sati />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/mjesecni-sati" 
          element={
            <ProtectedRoute>
              <MjesecniSati />
            </ProtectedRoute>
          } 
        />
        <Route
          path="/praznici"
          element={(
            <ProtectedRoute>
              <Praznici />
            </ProtectedRoute>
          )}
        />
        <Route 
          path="/moj-tjedan" 
          element={
            <RequireAuthRoute>
              <MojTjedan />
            </RequireAuthRoute>
          } 
        />
        <Route 
          path="/login" 
          element={<Login />} 
        />
        <Route 
          path="/not-authorized" 
          element={<Navigate to="/moj-tjedan" replace />} 
        />
        <Route 
          path="*" 
          element={<Navigate to="/sati" replace />} 
        />
      </Routes>
    </Router>
  );
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <LoadingProvider>
        <Root />
      </LoadingProvider>
    </AuthProvider>
  </React.StrictMode>
);